import type { UserTradingAnalyticsMcDistributionDto } from '@root/shared/api/TradeApi'

export enum UserTradingAnalyticsMcDistributionThreshold {
  Below100k = 'Below100k::UserTradingAnalyticsMcDistributionThreshold',
  From100kTo500k = 'From100kTo500k::UserTradingAnalyticsMcDistributionThreshold',
  Above500k = 'Above500k::UserTradingAnalyticsMcDistributionThreshold',
}

export interface UserTradingAnalyticsMcDistributionValue {
  count: number
  percent: number
}

export interface UserTradingAnalyticsMcDistribution
  extends Record<
    UserTradingAnalyticsMcDistributionThreshold,
    UserTradingAnalyticsMcDistributionValue
  > {}

export const fromDto = (
  dto: UserTradingAnalyticsMcDistributionDto,
): UserTradingAnalyticsMcDistribution => {
  return {
    [UserTradingAnalyticsMcDistributionThreshold.Below100k]: {
      count: dto.below100k.count,
      percent: dto.below100k.percent,
    },
    [UserTradingAnalyticsMcDistributionThreshold.From100kTo500k]: {
      count: dto.from100kTo500k.count,
      percent: dto.from100kTo500k.percent,
    },
    [UserTradingAnalyticsMcDistributionThreshold.Above500k]: {
      count: dto.above500k.count,
      percent: dto.above500k.percent,
    },
  }
}
